// extracted by mini-css-extract-plugin
export default {"baseCreativeManager":"baseCreativesManager_baseCreativeManager__-OIkz"};